/**
 @ngdoc service
 @name mapBookingTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    const mapBookingTileService = function(tileDataFactory) {

        const map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            const self = this;

            // Assigning tile factory function with parameters to variable
            const tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('bookingId'));
            if(rawTileData.jobCorporateURI){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('jobId', 'jobPrincipleURI', 'jobCorporateURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('jobId','jobPrincipleURI'));
            }
            if(!tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn1(tileFactory.field.newField('jobTitle'));
            }
            tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('candidateName','candidateURI'));
            if(!tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn1(tileFactory.field.newField('supplier'));
            }
            // TODO: "Job" missing in existing tile examples (to add in corporate column 1)

            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('workingAddress'));
            let hiringManager;
            if(rawTileData.hiringManagerFirstName){
                hiringManager = rawTileData.hiringManagerFirstName + ' ' + rawTileData.hiringManagerLastName;
            }
            if(tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationFieldWithLink('procurerOrgUnitName', 'procurerOrgName', 'businessURI'));
                tileFactory.addFieldToColumn2(tileFactory.field.newLinkJoinField('hiringManagerFirstName', 'hiringManagerLastName', 'hiringManagerURI'));
            }else{
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));
                tileFactory.addFieldToColumn2({label: objectTilesLabels.hiringManagerFirstName.label, value: hiringManager});
            }
            if( !rawTileData.isInterimBooking && tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitField(
                    'permFee',
                    rawTileData.payType.id,
                    lookupValues[rawTileData.payType.lookupKey][rawTileData.payType.id]
                ));
            }
            else {
                tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitField(
                    'chargeRate',
                    rawTileData.payType.id,
                    lookupValues[rawTileData.payType.lookupKey][rawTileData.payType.id]
                ));

            }
            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitField(
                'payRate',
                rawTileData.payType.id,
                lookupValues[rawTileData.payType.lookupKey][rawTileData.payType.id]
            ));

            if(rawTileData.isInterimBooking) {
                tileFactory.addFieldToColumn3(tileFactory.field.newField('taxStatus'));
            }

            if(!tileFactory.isPrincipal()){
                // TODO: ask for camelCase instead of snake_case to be passed in json feed
                if(rawTileData.attributeAutoScore) {
                    tileFactory.addFieldToColumn3(tileFactory.field.newField('attributeAutoScore'));
                }
                if(rawTileData.auditResult) {
                    tileFactory.addFieldToColumn3(tileFactory.field.newField('auditResult'));
                }
                if(rawTileData.auditScore) {
                    tileFactory.addFieldToColumn3(tileFactory.field.newField('auditScore'));
                }
            }

            // TODO: "Comments" missing in dataList, to add to column 3 in corporate
            if(!tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn4( (tileFactory.field.newTimeField('timeFromDistribution')));
            }
            if(rawTileData.isPermBooking){
               tileFactory.addFieldToColumn4(tileFactory.field.newField('permStartDate', 'date'));
            }
            else {
                tileFactory.addFieldToColumn4(tileFactory.field.newDateRangeField('interimStartDate','interimEndDate'));
            }
            if(rawTileData.isPermBooking && rawTileData.pendingFtcEx){
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('pendingFtcEx'));
            }
            if(rawTileData.isInterimBooking && !rawTileData.isShiftBooking){
                if(rawTileData.extensionCount > 0) {
                    tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('extensionCount', 'extensionURI'));
                }
                else{
                    tileFactory.addFieldToColumn4(tileFactory.field.newField('extensionCount'));
                }
                if(rawTileData.bookingChangeCount > 0) {
                    tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('bookingChangeCount', 'extensionURI'));
                }
                else{
                    tileFactory.addFieldToColumn4(tileFactory.field.newField('bookingChangeCount'));
                }
            }
            if(rawTileData.isInterimBooking && rawTileData.numberOfShifts > 0){
                tileFactory.addFieldToColumn4(tileFactory.field.newField('numberOfShifts'));
            }
            if(!tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn4(tileFactory.field.newField('comments'));
            }
            if(tileFactory.isPrincipal() && rawTileData.nonAuthorisedPlacement  && rawTileData.isPermBooking){
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('nonAuthorisedPlacement'));
            }
            if( !rawTileData.isInterimBooking && tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('orderingManager'));
            }

            tileFactory.addStatus(tileFactory.status.newTrueBooleanOrHide('pendingAmendment'));

            if(!tileFactory.isPrincipal() &&rawTileData.complianceStage ){
                tileFactory.addStageCollection(tileFactory.stageCollection.newStageCollection('complianceStage'));
            }

            // Adding status

            // bookingStatus
            // 576: "Open"
            // 583: "Closed"
            // authorisationStatus
            // 577: "Requested"
            // 578: "Awaiting Start"
            // 579: "Rejected"
            // 580: "In Progress"
            // 581: "Cancelled"
            // 582: "Completed"
            tileFactory.addStatus(tileFactory.status.newCombinedStatus('bookingStatus', 'authorisationStatus',
                // Positives
                [
                    [tileFactory.LOOKUP_VALUE.BOOKING_STATUS_OPEN, tileFactory.LOOKUP_VALUE.BOOKING_IN_PROGRESS],
                    [tileFactory.LOOKUP_VALUE.BOOKING_STATUS_CLOSED, tileFactory.LOOKUP_VALUE.BOOKING_COMPLETED]
                ],
                // Negatives
                [
                    [tileFactory.LOOKUP_VALUE.BOOKING_STATUS_CLOSED, tileFactory.LOOKUP_VALUE.BOOKING_CANCELLED],
                    [tileFactory.LOOKUP_VALUE.BOOKING_STATUS_CLOSED, tileFactory.LOOKUP_VALUE.BOOKING_REJECTED],
                    [tileFactory.LOOKUP_VALUE.BOOKING_STATUS_CLOSED, tileFactory.LOOKUP_VALUE.BOOKING_IN_PROGRESS]
                ],
                // Warnings
                [
                    [tileFactory.LOOKUP_VALUE.BOOKING_STATUS_OPEN, tileFactory.LOOKUP_VALUE.BOOKING_REQUESTED],
                    [tileFactory.LOOKUP_VALUE.BOOKING_STATUS_OPEN, tileFactory.LOOKUP_VALUE.BOOKING_AWAITING_START]
                ]
            ));
            tileFactory.addStatus(tileFactory.status.newStatus('amendmentStatus'));

            if (tileFactory.isPrincipal() && rawTileData.bookingFrameworkNameHoverText) {
                tileFactory.addStatus(tileFactory.status.newFrameworkStatus('bookingFrameworkNameHoverText'));
            }

            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapBookingTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapBookingTileService', mapBookingTileService);

}());
